import { ApiDateFilter, ApiDateFilterOperator } from "@/components/date-filter/date-filter.type.ts";

export function isDateFilterEmpty(f: ApiDateFilter | undefined): boolean {
  if (!f) return true;
  if (f.operator === ApiDateFilterOperator.preset) return !f.preset;
  return !f.value_from && !f.value_to;
}
